import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79m31.357-10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758M16 16.78l-1.176.838.434-1.377-1.16-.859 1.443-.013L16 14l.458 1.369 1.444.013-1.16.859.433 1.377zm-5.333-2.667-1.176.838.434-1.377-1.16-.859 1.443-.013.459-1.369.458 1.37 1.444.012-1.16.86.433 1.376zm10.666 0-1.175.838.433-1.377-1.16-.859 1.444-.013.458-1.369.459 1.37 1.443.012-1.16.86.434 1.376zm-10.666 5.334-1.176.838.434-1.377-1.16-.86 1.443-.012.459-1.37.458 1.37 1.444.013-1.16.859.433 1.377zm10.666 0-1.175.838.433-1.377-1.16-.86 1.444-.012.458-1.37.459 1.37 1.443.013-1.16.859.434 1.377z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagHnd = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagHnd_default = SvgFlagHnd;

export { FlagHnd_default as default };
